import React from "react"
import { Card, CardBody, Table, Badge } from "reactstrap"
import { Link } from "react-router-dom"

const RecentUsers = () => {
  // Dummy data for recent users - replace with real API data later
  const recentUsers = [
    {
      id: 1,
      name: "John Doe",
      email: "john@example.com",
      type: "Student",
      status: "Active",
      joinDate: "2024-01-15",
      avatar: "JD"
    },
    {
      id: 2,
      name: "Jane Smith",
      email: "jane@business.com",
      type: "Business",
      status: "Pending",
      joinDate: "2024-01-14",
      avatar: "JS"
    },
    {
      id: 3,
      name: "Mike Johnson",
      email: "mike@creator.com",
      type: "Creator",
      status: "Active",
      joinDate: "2024-01-13",
      avatar: "MJ"
    },
    {
      id: 4,
      name: "Sarah Wilson",
      email: "sarah@student.edu",
      type: "Student",
      status: "Under Review",
      joinDate: "2024-01-12",
      avatar: "SW"
    },
    {
      id: 5,
      name: "Tom Brown",
      email: "tom@company.com",
      type: "Business",
      status: "Active",
      joinDate: "2024-01-11",
      avatar: "TB"
    }
  ]

  const getStatusColor = (status) => {
    switch (status) {
      case 'Active': return 'success'
      case 'Pending': return 'warning'
      case 'Under Review': return 'info'
      case 'Suspended': return 'danger'
      default: return 'secondary'
    }
  }

  const getTypeColor = (type) => {
    switch (type) {
      case 'Student': return 'primary'
      case 'Business': return 'info'
      case 'Creator': return 'success'
      default: return 'secondary'
    }
  }

  return (
    <Card>
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h4 className="card-title">Recent Users</h4>
          <Link to="/user-list" className="btn btn-sm btn-outline-primary">
            View All Users
          </Link>
        </div>

        <div className="table-responsive">
          <Table className="table-nowrap mb-0">
            <thead className="table-light">
              <tr>
                <th>User</th>
                <th>Type</th>
                <th>Status</th>
                <th>Join Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {recentUsers.map((user) => (
                <tr key={user.id}>
                  <td>
                    <div className="d-flex align-items-center">
                      <div className="avatar-sm rounded-circle bg-primary d-flex align-items-center justify-content-center me-3">
                        <span className="text-white font-size-12">{user.avatar}</span>
                      </div>
                      <div>
                        <h6 className="mb-0">{user.name}</h6>
                        <small className="text-muted">{user.email}</small>
                      </div>
                    </div>
                  </td>
                  <td>
                    <Badge color={getTypeColor(user.type)} className="badge-soft">
                      {user.type}
                    </Badge>
                  </td>
                  <td>
                    <Badge color={getStatusColor(user.status)} className="badge-soft">
                      {user.status}
                    </Badge>
                  </td>
                  <td>
                    <span className="text-muted">{user.joinDate}</span>
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      <button className="btn btn-sm btn-outline-primary">
                        <i className="mdi mdi-eye"></i>
                      </button>
                      <button className="btn btn-sm btn-outline-secondary">
                        <i className="mdi mdi-pencil"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  )
}

export default RecentUsers